import {useEffect, useCallback} from 'react';
import {useConsole} from './consoleStore';

const useResizableConsole = (containerRef) => {
    const {setIsResizing, setConsoleHeight, isResizing,setIsMaximized} = useConsole();

    const startResizing = useCallback((mouseDownEvent) => {
        mouseDownEvent.preventDefault();
        setIsResizing(true);
    }, [setIsResizing]);

    const stopResizing = useCallback(() => {
        setIsResizing(false);
    }, [setIsResizing]);

    const resizeConsole = useCallback((event) => {
        if (containerRef.current) {
            const containerHeight = containerRef.current.parentElement.clientHeight;
            const maxHeight = containerHeight * 0.98; // 98% of the container height auto maximize
            const newHeight = window.innerHeight - event.clientY;
            if (newHeight <= maxHeight) {
                setConsoleHeight(`${newHeight}px`);
            } else {
                stopResizing();
                setIsMaximized(true);
                setConsoleHeight('100%');
            }
        }
    }, [setConsoleHeight, stopResizing, containerRef]);


    useEffect(() => {
        if (isResizing) {
            window.addEventListener('mousemove', resizeConsole);
            window.addEventListener('mouseup', stopResizing);
        } else {
            window.removeEventListener('mousemove', resizeConsole);
            window.removeEventListener('mouseup', stopResizing);
        }

        return () => {
            window.removeEventListener('mousemove', resizeConsole);
            window.removeEventListener('mouseup', stopResizing);
        };
    }, [isResizing, resizeConsole, stopResizing]);
    return {startResizing};
};

export default useResizableConsole;
